import React from "react";
import Footer from "../../component/Footer";
import SwitchTabs from "../../component/SwitchTab";
import smartphone_line from "../../images/smartphone-line.svg";
import email_line from "../../images/mail-line.svg";
import India_flag from "../../images/india-logo.png";
import DefaultButton from "../../component/DefaultButton";
import ErrorComponent from "../../component/ErrorComponent";
import DHSplashScreen from "../../component/DHSplashScreen";
import Prajavani_logo from "../../images/prajavani-logo-img.svg";
import SocialLogin from "../../component/SocialLogin";
import { createPasswordlessCode } from "supertokens-web-js/recipe/thirdpartypasswordless";
import { useNavigate } from "react-router-dom";
import {
  EMAIL_REGEX,
  GENERAL_ERROR_MSG,
  INFO_MSG_EMAIL,
  INFO_MSG_PHONE,
  PRAJAVANI_EMAIL_TAB,
  PRAJAVANI_INVALID_EMAIL_MSG,
  PRAJAVANI_INVALID_PHONE_NUMBER_MSG,
  PRAJAVANI_MOBILE_TAB,
  PRAJAVANI_PRIVACY_POLICY_URL,
  PRAJAVANI_TERMS_URL,
  email_tab_indetifier,
  mobile_tab_indetifier,
} from "../../contant";
import Tooltip from "../../component/Tooltip";
import { toast } from "react-toastify";

const tabsData = [
  {
    tabName: PRAJAVANI_MOBILE_TAB,
    tabLogo: smartphone_line,
    tabIdentifier: mobile_tab_indetifier,
  },
  {
    tabName: PRAJAVANI_EMAIL_TAB,
    tabLogo: email_line,
    tabIdentifier: email_tab_indetifier,
  },
];

export default function PrajavaniLoginPage({ emailRequired, phoneNumberRequired, signupMessage }) {
  const [tab, setTab] = React.useState(
    emailRequired
      ? PRAJAVANI_EMAIL_TAB
      : localStorage.getItem("tab_detail") === PRAJAVANI_EMAIL_TAB ||
        localStorage.getItem("tab_detail") === PRAJAVANI_MOBILE_TAB
        ? localStorage.getItem("tab_detail")
        : PRAJAVANI_MOBILE_TAB
  );
  const [formData, setFormData] = React.useState({
    email: "",
    phone: "",
  });
  const [inputError, setInputError] = React.useState(null);
  const [isInputFocused, setIsInputFocused] = React.useState(false);
  const [isDisableButton, setIsDisableButton] = React.useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    let { name, value } = e.target;
    // Sanitize the value if the input name is 'phone'
    if (name === "phone") {
      value = value.replace(/\D/g, "");
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setInputError("");
  };

  async function sendMagicLink() {
    setIsDisableButton(true);
    setIsInputFocused(false);
    const responsePayload =
      tab === PRAJAVANI_MOBILE_TAB
        ? { phoneNumber: `+91${formData.phone}` }
        : { email: formData.email };
    const errMsg =
      tab === PRAJAVANI_MOBILE_TAB
        ? PRAJAVANI_INVALID_PHONE_NUMBER_MSG
        : PRAJAVANI_INVALID_EMAIL_MSG;
    const infoMsg =
      tab === PRAJAVANI_MOBILE_TAB ? INFO_MSG_PHONE : INFO_MSG_EMAIL;
    if (formData.email && !EMAIL_REGEX.test(formData.email)) {
      setInputError(errMsg);
      setIsDisableButton(false);
      return;
    }
    if (formData.phone || formData.email) {
      try {
        let response = await createPasswordlessCode(responsePayload);
        if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
          // this can happen due to automatic account linking. See that section in our docs.
        } else {
          // Magic link sent successfully.
          toast.info(infoMsg);
          navigate("/auth/verify_otp");
          localStorage.setItem("user_login_detail", JSON.stringify(formData));
          localStorage.setItem("tab_detail", tab);
        }
      } catch (err) {
        console.log("errorMessage", err);
        if (err.isSuperTokensGeneralError === true) {
          // this may be a custom error message sent from the API by you,
          // or if the input email / phone number is not valid.
          setInputError(errMsg);
        } else {
          toast.error(GENERAL_ERROR_MSG);
        }
      } finally {
        setIsDisableButton(false);
      }
    } else {
      setInputError(errMsg);
      setIsDisableButton(false);
    }
  }
  return (
    <div className="xxl:min-h-dvh xxxl:flex xxxl:flex-row xxxl:items-center xxxl:justify-center short-screen-spacing">
      <div className="flex flex-row w-full text-center justify-center lg:pt-8 px-5 md:p-1 xxxl:pt-0 sm:min-h-mobile">
        <DHSplashScreen
          className={"div-with-bg-prajavani"}
          logoImage={Prajavani_logo}
        />
        <div className="w-1/2 shadow-md rounded-2xl bg-white ml-2 pt-4 sm:w-full sm:ml-0 sm:flex sm:flex-col sm:justify-between">
          <div className="lg:px-4 w-full">
            <div className="w-full flex justify-center items-center text-center">
              <p className="w-2/3 sm:w-full px-2 flex justify-center items-center text-center text-gray-900 font-bold mb-4 text-[28px] whitespace-pre-wrap">
                {`ಲಾಗ್ ಇನ್ ಆಗಿರಿ \nಅಥವಾ ನಿಮ್ಮ ಖಾತೆ ರಚಿಸಿ`}
              </p>
            </div>
            <fieldset disabled={isDisableButton} className="contents w-full">
              <form onSubmit={(e) => e.preventDefault()}>
                {!phoneNumberRequired && !emailRequired ? <div className="w-full flex justify-center">
                  <SwitchTabs
                    data={tabsData}
                    setTab={setTab}
                    setInputError={setInputError}
                    tab={tab}
                  />
                </div> : signupMessage ?
                    <p className="text-base text-[#999999] max-w-[23rem] mx-auto -mb-10 mt-16">{signupMessage}</p>
                  : <div className="mt-10"></div>}
                <div className="w-full flex justify-center items-center lg:px-9 md:px-0 sm:px-2">
                  {inputError ? (
                    <>
                      {(tab === PRAJAVANI_MOBILE_TAB &&
                        formData.phone === "") ||
                        (tab === PRAJAVANI_EMAIL_TAB && formData.email === "") ? (
                        <Tooltip />
                      ) : (
                        <ErrorComponent
                          errorMsg={inputError}
                          onClick={() => setInputError("")}
                          className={
                            "w-[55%] lg:w-full md:w-full sm:w-full xs:w-full"
                          }
                        />
                      )}
                    </>
                  ) : (
                    <div className="mt-16"></div>
                  )}
                </div>
                {tab === PRAJAVANI_MOBILE_TAB ? (
                  <div className="w-full flex justify-center items-center lg:px-9 md:px-0 sm:px-2">
                    <div
                      className="flex justify-center items-center w-3/5 sm:w-full lg:w-full"
                      style={{ paddingBottom: "0.5px" }}
                    >
                      <button
                        className={`flex items-center gap-1 text-base text-gray-500 px-4 sm:px-1.5 py-2 border border-solid border-gray-300 border-r-0 pointer-events-none shadow-sm rounded-md rounded-r-none focus:outline-none focus:border-[#D19625] focus:ring-1 focus:ring-[#D19625] ${
                          (inputError || isInputFocused) &&
                          "!border-[#D19625] focus:border-[#D19625] focus:ring-[#D19625]"
                          }`}
                        type="button"
                      >
                        <img
                          src={India_flag}
                          alt="flag"
                          className="items-center max-w-8 h-auto"
                        />{" "}
                        +91
                      </button>
                      <input
                        type="tel"
                        name="phone"
                        id="phone"
                        maxLength={10}
                        className={`w-full text-base placeholder:text-[#6B7280] !leading-6 text-gray-500 pl-3.5 sm:pl-2 pr-3.5 sm:pr-2 py-3 pt-[13px] border border-solid border-gray-300 border-l-0 focus:outline-none focus:border-[#D19625] focus:ring-1 focus:ring-[#D19625] shadow-sm rounded-md rounded-l-none  ${
                          (inputError || isInputFocused) &&
                          "!border-[#D19625] focus:border-[#D19625] focus:ring-[#D19625]"
                          }`}
                        placeholder="ನಿಮ್ಮ ಮೊಬೈಲ್ ನಂಬರ್ ನಮೂದಿಸಿ"
                        value={formData.phone}
                        onChange={handleChange}
                        onFocus={() => {
                          setIsInputFocused(true);
                        }}
                        onBlur={() => {
                          setIsInputFocused(false);
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="w-3/5 sm:w-full lg:w-full mx-auto flex justify-center items-center lg:px-9 md:px-0 sm:px-2">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      className={`w-full lg:w-full md:w-full sm:w-full xs:w-full text-base text-gray-500 pl-3.5 pr-2 pb-3 pt-[13px] border border-solid border-gray-300 tracking-[0px] leading-6 focus:outline-none focus:border-[#D19625] focus:ring-1 focus:ring-[#D19625] shadow-sm rounded-md ${
                        inputError ? `!border-[#D19625]` : ""
                        }`}
                      placeholder="ನಿಮ್ಮ ಇಮೇಲ್ ಐಡಿ ದಾಖಲಿಸಿ"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                )}
                <div className="w-full flex justify-center items-center mb-8 mt-4 lg:px-9 md:px-0 sm:px-2">
                  <DefaultButton
                    label={"ಮುಂದುವರಿಸಿ"}
                    className={
                      "bg-amber-255 !text-gray-900 font-notoSans w-3/5 lg:w-full md:w-full sm:w-full xs:w-full"
                    }
                    onClick={sendMagicLink}
                    disabled={isDisableButton}
                    type={"submit"}
                  />
                </div>
              </form>
              {!phoneNumberRequired ? <>
                <div className="mx-auto w-3/5 lg:w-full md:w-full sm:w-full xs:w-full flex justify-center mb-1 lg:px-9 md:px-0 sm:px-2">
                  <div className="w-full flex flex-row justify-between space-x-2">
                    <div className="w-full pt-2.5">
                      <div className="divider-clr-section border-t"></div>
                    </div>
                    <p className="min-w-fit text-[#999] text-base font-medium font-notoSans leading-normal">
                      ಅಥವಾ ಈ ಖಾತೆಯೊಂದಿಗೆ ಮುಂದುವರಿಸಿ
                    </p>
                    <div className="w-full pt-2.5">
                      <div className="divider-clr-section border-t"></div>
                    </div>
                  </div>
                </div>
                <SocialLogin setIsDisableButton={setIsDisableButton} />
              </> : <div className="mt-28"></div>}
              <div className="w-full flex justify-center mt-5 mb-6">
                <div className="w-2/3 text-[#999] text-sm font-normal align-center item center px-12 font-notoSans leading-6 lg:w-full">
                  ಸೈನ್ ಇನ್ ಆಗುವ ಅಥವಾ ಖಾತೆ ರಚಿಸುವ ಮೂಲಕ, ನಮ್ಮ{" "}
                  <a
                    className={`font-roboto text-[#0087C1] underline cursor-pointer font-bold ${
                      isDisableButton && "pointer-events-none"
                      }`}
                    href={PRAJAVANI_TERMS_URL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    ಷರತ್ತು ಹಾಗೂ ನಿಯಮಗಳು
                  </a>{" "}
                  ಮತ್ತು{" "}
                  <a
                    className={`font-roboto text-[#0087C1] underline cursor-pointer font-bold ${
                      isDisableButton && "pointer-events-none"
                      }`}
                    href={PRAJAVANI_PRIVACY_POLICY_URL}
                    target="_blank"
                    rel="noreferrer"
                  >
                    ಗೋಪ್ಯತಾ ನೀತಿಗೆ
                  </a>
                  {" "} ನೀವು ಸಮ್ಮತಿಸುತ್ತೀರಿ.
                </div>
              </div>
            </fieldset>
          </div>
          <Footer footerLable={"ನಿಮ್ಮ ಲಾಗಿನ್, ಈಗ ಸರಳ"} />
        </div>
      </div>
    </div>
  );
}
